// Used to construct an array of routes that can be used to implement file-based routing.

const PRESERVED = import.meta.glob('/src/pages/(_app|404).tsx', { eager: true });
const ROUTES = import.meta.glob('/src/pages/**/[a-z[]*.tsx', { eager: true });

export default function getRoutes() {
  const preserved = Object.keys(PRESERVED).reduce((preserved, file) => {
    const key = file.replace(/\/src\/pages\/|\.tsx$/g, '');
    // @ts-expect-error
    return { ...preserved, [key]: PRESERVED?.[file].default };
  }, {});

  const routes = Object.keys(ROUTES).map(route => {
    const path = route
      .replace(/\/src\/pages|index|\.tsx$/g, '')
      .replace(/\[\.{3}.+\]/, '*')
      .replace(/\[(.+)\]/, ':$1');

    // @ts-expect-error
    return { path, component: ROUTES?.[route].default };
  });

  return { preserved, routes };
}
